"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { trackGaEvent } from "@/lib/gtag";

/**
 * SPA-aware GA4 page_view tracker. Next's App Router navigates on the client,
 * so gtag's automatic page_view (which only fires on a full document load)
 * would record just one view per session — hiding the entire in-app customer
 * flow. We disable gtag's auto page_view (send_page_view:false in the layout)
 * and fire one here on every pathname change, including the initial mount.
 *
 * Inert when GA isn't configured — trackGaEvent no-ops without window.gtag.
 */
export function GaRouteTracker() {
  const pathname = usePathname();
  const last = useRef<string | null>(null);

  useEffect(() => {
    if (last.current === pathname) return;
    last.current = pathname;
    trackGaEvent("page_view", {
      page_path: pathname,
      page_location: typeof window !== "undefined" ? window.location.href : undefined,
      page_title: typeof document !== "undefined" ? document.title : undefined,
    });
  }, [pathname]);

  return null;
}
